import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AlarmIcon from '@material-ui/icons/Alarm';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import LockIcon from '@material-ui/icons/Lock';
import DehazeIcon from '@material-ui/icons/Dehaze';
import ReturnIcon from '@material-ui/icons/KeyboardReturn';
import PhotoFilterIcon from '@material-ui/icons/PhotoFilter';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import FormatIndentDecreaseIcon from '@material-ui/icons/FormatIndentDecrease';
import SvgIcon from '@material-ui/icons/CloudDownload';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AirplayIcon from '@material-ui/icons/Airplay';
import Tooltip from "@material-ui/core/Tooltip";
import {ArrowRightIcon} from "@material-ui/pickers/_shared/icons/ArrowRightIcon";
import {ArrowLeftIcon} from "@material-ui/pickers/_shared/icons/ArrowLeftIcon";
import LaunchIcon from '@material-ui/icons/Launch';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import CallMadeIcon from '@material-ui/icons/CallMade';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import FilterCenterFocusIcon from '@material-ui/icons/FilterCenterFocus';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(0),
    },
  },
}));


function IconButtonsCustom(props) {
  const classes = useStyles();

  return (
    <Tooltip title={props.hover}>
      <IconButton disabled={props.disabled} aria-label={props.label} onClick={props.onClick}>
        {(() => {
          switch (props.label) {
            case 'delete':
              return <DeleteIcon/>;
            case 'edit':
              return <EditIcon/>;
            case 'search':
              return <SearchIcon/>;
            case 'forgot':
              return <LockIcon/>;
            case 'detail':
              return <DehazeIcon/>;
            case 'return':
              return <ReturnIcon/>;
            case'dispatch':
              return <CallMissedOutgoingIcon/>
            case'received':
              return <AirplayIcon/>
            case'filter':
              return <PhotoFilterIcon/>;
            case'next':
              return <ArrowRightIcon/>;
            case 'back':
              return <ArrowLeftIcon/>;
            case 'status':
              return <CallMadeIcon/>;
            case 'data':
              return <FormatIndentDecreaseIcon/>
            case 'select':
              return <LaunchIcon/>
            case 'cheked':
                return <AssignmentTurnedInIcon/>
            case 'download':
                return <SvgIcon/>
            case 'filter-param':
              return <FilterCenterFocusIcon/>

            default:
              return <EditIcon/>;
          }
        })()}
      </IconButton>
    </Tooltip>

  );
}

export {IconButtonsCustom}
